module.exports = __webpack_public_path__ + "img/poll-people.44ee47eb.svg";